import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, Plus, ChevronRight } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Loader, PhotoThumb } from "@/components/Common";

export default function MyPlants() {
  const [plants, setPlants] = useState(null);
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    api.get("/plants").then(({ data }) => setPlants(data));
    api.get("/analyses").then(({ data }) => setAnalyses(data.filter((a) => !a.plant_id)));
  }, []);

  if (!plants) return <Loader />;

  return (
    <div className="space-y-6 px-5 py-6" data-testid="my-plants-page">
      <div className="flex items-end justify-between">
        <div>
          <p className="eyebrow">Area personale</p>
          <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Le mie piante</h1>
        </div>
        <Link to="/analisi/nuova" className="btn-primary !px-4 !py-2.5 text-xs" data-testid="new-analysis-button"><Plus size={14} /> Analisi</Link>
      </div>

      {plants.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-[#C9A96E] bg-white p-8 text-center" data-testid="plants-empty">
          <Leaf className="mx-auto text-[#C9A96E]" />
          <p className="mt-3 font-serif text-xl text-[#0D2517]">Nessuna pianta salvata</p>
          <p className="mt-1 text-sm text-[#5b6b60]">Al termine di un'analisi potrai salvarla qui per seguirne lo storico.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {plants.map((p) => (
            <Link key={p.id} to={`/piante/${p.id}`} className="flex items-center gap-4 rounded-2xl border border-[#ddc69c]/70 bg-white p-3 transition-shadow hover:shadow-md" data-testid={`plant-card-${p.id}`}>
              {p.cover_photo_id ? <PhotoThumb id={p.cover_photo_id} className="h-16 w-16" /> : <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-[#f8f3e9]"><Leaf className="text-[#C9A96E]" /></span>}
              <div className="flex-1">
                <p className="font-semibold text-[#0D2517]">{p.name}</p>
                <p className="botanical text-sm text-[#B39257]">{p.species_botanical || p.species_common}</p>
                <p className="text-[11px] text-[#8a958d]">{p.analyses_count} analisi · {p.cultivation === "vaso" ? "in vaso" : p.cultivation === "piena_terra" ? "piena terra" : "coltivazione n.d."}</p>
              </div>
              <ChevronRight size={18} className="text-[#C9A96E]" />
            </Link>
          ))}
        </div>
      )}

      {analyses.length > 0 && (
        <section data-testid="unsaved-analyses">
          <p className="eyebrow">Analisi non associate a una pianta</p>
          <div className="space-y-2">
            {analyses.map((a) => (
              <Link key={a.id} to={`/analisi/${a.id}`} className="flex items-center justify-between rounded-xl border border-[#ddc69c]/70 bg-white p-3 text-sm" data-testid={`analysis-link-${a.id}`}>
                <span>{a.species?.common_name || "Analisi in corso"} · {fmtDate(a.created_at)}</span>
                <ChevronRight size={16} className="text-[#C9A96E]" />
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
